import { Property } from '../../../types';
import { HealthIssue } from '../../../types/inventoryHealth';

export function isLotProperty(tipo?: string | null): boolean {
  if (!tipo) return false;
  const norm = tipo.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return norm.includes('lote') || norm.includes('terreno');
}

export function checkZeroAntiguedadRule(property: Property): HealthIssue | null {
  if (isLotProperty(property.tipoinmueble)) {
    return null;
  }

  const antiguedad = property.antiguedad;

  // Resalta los que tienen antigüedad de 0 (o numéricamente 0 / '0')
  const isZero =
    antiguedad === 0 ||
    (typeof antiguedad === 'string' && (antiguedad as string).trim() === '0');

  if (isZero) {
    return {
      ruleId: 'zero_antiguedad',
      ruleName: 'Antigüedad en 0 Años',
      severity: 'warning',
      message: `${property.tipoinmueble || 'Inmueble'} registra antigüedad de 0 años. Verificar si es proyecto sobre planos/estreno o dato por corregir.`,
      field: 'antiguedad',
      currentValue: antiguedad,
      suggestedFix: 'Verificar si es nuevo/sobre planos o colocar los años reales de construcción.',
    };
  }

  return null;
}
